import styled from "styled-components";

export const IconTemp = styled.img`
  width: 100px;
  height: 100px;
  color: white;
`;
